export enum LogLevel {
    NONE,
    LOG,
    ERROR,
    WARN,
    INFO,
    DEBUG,
    TRACE
}